
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "arrow-right-long.icon",
  "use": "arrow-right-long.icon-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"arrow-right-long.icon\"><g id=\"arrow-right-long.icon_List-product\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"arrow-right-long.icon_Page-Product-detail\" transform=\"translate(-230 -221)\" fill=\"#FFF\"><path id=\"arrow-right-long.icon_ion-android-arrow-back---Ionicons\" d=\"M245 227.579v1.842h-11.404l5.22 5.263L237.5 236l-7.5-7.5 7.5-7.5 1.36 1.316-5.264 5.263z\" /></g></g></symbol>"
});
    sprite.add(symbol);
    export default class ArrowRightLongIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="arrow-right-long.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/arrow-right-long.icon.svg